{
  "it": {
    "pagination": {
      "previous": "Pagina precedente",
      "next": "Pagina successiva",
      "page_report": "Pagina {page} di {total}",
      "report": "Da {first} a {last} di {total}",
      "total": "Elementi totali: {total}"
    }
  }
}
